// extracted by mini-css-extract-plugin
export default {"root":"CfgFf60NTXsjSE6Lco62"};